import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import { ToastContainer, toast } from 'react-toastify';
import { bannerAPI, newsAPI, videoAPI, adsAPI, imagaeAPI, YouTubevideoAPI, BengaluruNewsAPI, KarnatakaNewsAPI, NationalNewsAPI, YouTubevideoMetroAPI } from '../../services/api';
import Header from './Header';
import Footer from './Footer';

// Swiper CSS
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// React Toastify CSS
import 'react-toastify/dist/ReactToastify.css';

// ---------- Main Homepage Component ----------
const PrivacyPolicy = () => {
    // State
    const [loading, setLoading] = useState(false);
    const [banners, setBanners] = useState([]);
    const [allNews, setAllNews] = useState([]);
    const [videos, setVideos] = useState([]);
    const [ads, setAds] = useState([]);
    const [temperature, setTemperature] = useState('Loading...');
    const [youtubevideos, setYouTubeVideos] = useState([]);
    const [youtubevideosmetro, setYouTubeVideosMetro] = useState([]);
    const [error, setError] = useState(null);

    const [bengaluruallNews, setBengaluruAllNews] = useState([]);
    const [karnatakaallNews, setKarnatakaAllNews] = useState([]);
    const [nationalallNews, setNationalAllNews] = useState([]);


    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        return new Date(dateStr).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });

    };





    const fetchAds = async () => {
        setLoading(true);
        try {
            const res = await adsAPI.getAll();
            setAds(res.data.data);
        } catch (error) {
            console.error("Error fetching ads:", error);
        }
        finally {
            setLoading(false);
        }
    };



    const getAds = () =>
        ads.filter(n => n.status === 'active');



    useEffect(() => {



        fetchAds();


        fetch('https://wttr.in/Bengaluru?format=j1')
            .then(res => res.json())
            .then(data => {
                setTemperature(data.current_condition[0].temp_C + '°C');
            })
            .catch(() => setTemperature('N/A'));

    }, []);


    if (loading) {
        return (
            <div className="main-content" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }



    // ---------- Render ----------
    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} />

            <Header temperature={temperature} />


            {/* ===== MAIN CONTENT ===== */}
            <main>

                {/* ---------- BENGALURU NEWS ---------- */}
                <section className="trending-posts-4__area trending-posts-4__space grey-bg section-space-bottom">
                    <div className="container custom-container">
                        <div className="trending-posts-4__top heading-display__wrap">
                            <div className="section-heading__wrap">
                                <h3 className="section__title wow custom-anim-left" data-wow-duration="1s" data-wow-delay="0.1s">
                                    Privacy Policy
                                </h3>
                                <div className="section__border wow custom-anim-left" data-wow-duration="1s" data-wow-delay="0.1s" />
                            </div>

                        </div>
                        <div className="row mb-minus-24">
                            <div className="col-lg-8 primary_bg4">

                                <div className="trending-posts-4__wrapper mb-24">



                                    <div>



                                        <p className="mb-24">
                                            Bangalore Metro News TV ("we," "our," or "us") is committed to protecting
                                            the privacy of our visitors, readers, and users. This Privacy Policy explains
                                            how we collect, use, disclose, and safeguard your information when you visit
                                            our website and use our services.
                                        </p>

                                        <p className="mb-24">
                                            By accessing or using Bangalore Metro News TV, you agree to the terms of
                                            this Privacy Policy. If you do not agree with the terms outlined herein, please
                                            discontinue the use of our website.
                                        </p>

                                        <h2>1. Information We Collect</h2>

                                        <h3>Personal Information</h3>
                                        <p className="mb-24">
                                            We may collect personal information that you voluntarily provide to us, including:
                                        </p>
                                        <ul className="mb-24">
                                            <li>Name</li>
                                            <li>Email Address</li>
                                            <li>Phone Number</li>
                                            <li>Postal Address</li>
                                            <li>Information submitted through contact forms, subscriptions, or inquiries</li>
                                        </ul>

                                        <h3 className="mb-24">Non-Personal Information</h3>
                                        <p className="mb-24">
                                            We may automatically collect certain information when you visit our website,
                                            including:
                                        </p>
                                        <ul className="mb-24">
                                            <li>IP Address</li>
                                            <li>Browser Type</li>
                                            <li>Device Information</li>
                                            <li>Operating System</li>
                                            <li>Pages Visited</li>
                                            <li>Date and Time of Access</li>
                                            <li>Website Usage Statistics</li>
                                        </ul>

                                        <h2 className="mb-24">2. How We Use Your Information</h2>

                                        <p className="mb-24">We may use the information collected to:</p>

                                        <ul className="mb-24">
                                            <li>Provide and improve our services and website experience.</li>
                                            <li>Respond to inquiries, feedback, and requests.</li>
                                            <li>Send newsletters, updates, and important notifications.</li>
                                            <li>Monitor website performance and security.</li>
                                            <li>Analyze user behavior to improve content and functionality.</li>
                                            <li>Comply with legal and regulatory requirements.</li>
                                        </ul>

                                        <h2 className="mb-24">3. Cookies and Tracking Technologies</h2>

                                        <p className="mb-24">
                                            Bangalore Metro News TV may use cookies and similar tracking technologies
                                            to enhance user experience and analyze website traffic.
                                        </p>

                                        <p className="mb-24">
                                            Cookies help us understand how visitors interact with our website and enable
                                            certain features to function properly. Users may choose to disable cookies
                                            through their browser settings; however, some website features may not function
                                            correctly.
                                        </p>

                                        <h2 className="mb-24">4. Information Sharing and Disclosure</h2>

                                        <p className="mb-24">
                                            We do not sell, rent, or trade your personal information to third parties.
                                            We may share information only under the following circumstances:
                                        </p>

                                        <ul className="mb-24">
                                            <li>When required by law, regulation, or legal process.</li>
                                            <li>To protect the rights, safety, and security of users or the public.</li>
                                            <li>With trusted service providers assisting in website operations.</li>
                                            <li>To investigate fraud, misuse, or unauthorized activities.</li>
                                        </ul>

                                        <h2 className="mb-24">5. Third-Party Links</h2>

                                        <p className="mb-24">
                                            Our website may contain links to third-party websites, government portals,
                                            social media platforms, or external resources. We are not responsible for the
                                            privacy practices or content of such external websites.
                                        </p>

                                        <p className="mb-24">
                                            Users are encouraged to review the privacy policies of third-party websites
                                            before providing any personal information.
                                        </p>

                                        <h2 className="mb-24">6. Data Security</h2>

                                        <p className="mb-24">
                                            We implement appropriate technical and organizational measures to protect your
                                            personal information from unauthorized access, disclosure, alteration, or destruction.
                                        </p>

                                        <p className="mb-24">
                                            While we strive to maintain the highest security standards, no method of
                                            transmission over the Internet or electronic storage is completely secure.
                                            Therefore, we cannot guarantee absolute security.
                                        </p>

                                        <h2 className="mb-24">7. Children's Privacy</h2>

                                        <p className="mb-24">
                                            Bangalore Metro News TV does not knowingly collect personal information
                                            from children under the age of 13. If we become aware that such information
                                            has been collected, appropriate steps will be taken to remove it promptly.
                                        </p>

                                        <h2 className="mb-24">8. Your Rights</h2>

                                        <p className="mb-24">
                                            Depending on applicable laws, users may have the right to:
                                        </p>

                                        <ul className="mb-24">
                                            <li>Access personal information held by us.</li>
                                            <li>Request correction of inaccurate information.</li>
                                            <li>Request deletion of personal information where legally permitted.</li>
                                            <li>Withdraw consent for certain processing activities.</li>
                                            <li>Request information regarding how personal data is used.</li>
                                        </ul>

                                        <h2 className="mb-24">9. Retention of Information</h2>

                                        <p className="mb-24">
                                            We retain personal information only for as long as necessary to fulfill the
                                            purposes outlined in this Privacy Policy, comply with legal obligations,
                                            resolve disputes, and enforce our policies.
                                        </p>

                                        <h2 className="mb-24">10. Changes to This Privacy Policy</h2>

                                        <p className="mb-24">
                                            We may update this Privacy Policy from time to time to reflect changes in
                                            legal requirements, technology, or our practices. Any updates will be posted
                                            on this page with a revised effective date.
                                        </p>

                                        <p className="mb-24">
                                            Continued use of the website after such changes constitutes acceptance of the
                                            updated Privacy Policy.
                                        </p>

                                        <h2 className="mb-24">11. Contact Us</h2>

                                        <p className="mb-24">
                                            If you have any questions, concerns, or requests regarding this Privacy Policy,
                                            please contact us:
                                        </p>

                                        <p className="mb-24">
                                            <strong>Bangalore Metro News TV</strong>
                                            <br />
                                            Email: info@bangaloremetronews.in
                                            <br />
                                            Phone: 080-26623007
                                            <br />
                                            Address: #65, 3rd Floor, SSR Archade, Gandhi Bazaar Main Road, Basavanagudi, Bangalore, Karnataka - 560004
                                        </p>

                                        <p className="mb-24">
                                            By using Bangalore Metro News TV, you acknowledge that you have read and
                                            understood this Privacy Policy and agree to its terms.
                                        </p>

                                    </div>


                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="blog-sidebar__wrapper">



                                    <div
                                        className="blog-sidebar__wrap mb-20 wow fadeInUp"
                                        data-wow-duration="0.7s"
                                        data-wow-delay="0.2s"
                                    >
                                        <h3 className="blog-sidebar__title">Advertisement</h3>
                                        <div className="blog-sidebar__gallery blog-sidebar__gallery-2">


                                            {ads.length > 0 && (

                                                <>


                                                    {ads.map((ad) => (

                                                        <div className="" key={ad.id}>

                                                            <img src={`${imagaeAPI}/uploads/ads/${ad.ads_photo}`} alt={ad.ads_title} />

                                                        </div>

                                                    ))
                                                    }

                                                </>

                                            )}



                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>














            </main >

            {/* ===== FOOTER ===== */}

            < Footer />

        </>
    );
};

// ---------- SUBCOMPONENTS ----------



export default PrivacyPolicy;